<div class="manage-payment-form-container">
    <div class="bolt-container">
        <bolt-progress-bar appFocusOnInit arialabel="Update automatic payment progress value is 100%" class="progress-bar-container to-container" value="100"></bolt-progress-bar>
        <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Update automatic
            payment information: confirmation</h1>
        <div class="bolt-row">
            <div class="bolt-col-12">
                @if (apiCallSuccessful) {
                <bolt-notification class="bolt-space-bottom-2xl to-container" type="success">Your automatic payment changes have been confirmed.
                </bolt-notification>
                <app-payment-sub-header>Confirmation details</app-payment-sub-header>
                <div class="bolt-space-bottom-2xl">
                    <div class="bolt-row">
                        <div class="bolt-col">
                            <strong>Automatic payment change submitted date:</strong>
                        </div>
                        <div class="bolt-col">
                            {{formattedSubmittedDate}}
                        </div>
                    </div>
                    <div class="bolt-row">
                        <div class="bolt-col">
                            <strong>Automatic payment change effective date:</strong>
                        </div>
                        <div class="bolt-col">
                            {{formattedEffectiveDate}}
                        </div>
                    </div>
                </div>
                @if (shouldShowOutstandingPayment) {
                <app-payment-sub-header>Outstanding payment due</app-payment-sub-header>
                <p class="bolt-space-bottom-2xl">
                    A payment of {{amountDue}} will be drafted on {{amountDueDate | date:'MM/dd/yyyy'}} from {{oldPaymentMethodDisplayString}}.
                    <br>
                    To use a different payment method you can make a one-time payment manually before that date.
                </p>
                }
                } @else {
                <bolt-notification class="bolt-space-bottom-2xl to-container" type="error" id="error-notification">
                    {{ editErrorMessage() }}
                </bolt-notification>
                }
            </div>
        </div>
    </div>
    @if (amountDueExists() && (automaticPaymentSuspended ||
    canPayNow)) {
    <bolt-button-bar>
        <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
        <is-button id="secondary-button" (click)="secondayNavigation(secondaryButton)" slot="back">{{secondaryButton.label}}</is-button>
        @if (upNextLabel) {
        <is-button slot="forward" id="submit-button" [type]="solid" (click)="onContinue()">
            {{upNextLabel}}</is-button>
        }
    </bolt-button-bar>
    } @else {
    <bolt-button-bar>
        <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
        <is-button id="secondary-button" (click)="secondayNavigation(secondaryButton)" slot="forward">{{secondaryButton.label}}</is-button>
    </bolt-button-bar>
    }
</div>